import { takeLatest, put, call, fork } from 'redux-saga/effects';
import callApi from 'utils/api';
import * as actionTypes from './constants';
import {
  fetchPlantsSuccess,
  fetchPlantsFailure,
  fetchWorkingHoursSuccess,
  fetchWorkingHoursFailure,
  updateWorkingHoursSuccess,
  updateWorkingHoursFailure,
  restoreWorkingHoursSuccess,
  restoreWorkingHoursFailure,
} from './working-hours-actions';

export function* doFetchPlants(action) {
  try {
    const results = yield call(callApi, {
      endpoint: 'refdata/lookup/workcenters',
      options: {
        errorMessage: 'Could not fetch plants',
        retryAction: action,
      },
    });
    yield put(fetchPlantsSuccess(results));
  } catch (err) {
    yield put(fetchPlantsFailure(err));
  }
}

export function* doFetchWorkingHours(action) {
  try {
    const results = yield call(callApi, {
      endpoint: `planning/workingHours/${action.payload.id}`,
      options: {
        errorMessage: `Could not fetch working hours for ${action.payload.id}`,
        retryAction: action,
      },
    });
    yield put(fetchWorkingHoursSuccess(results));
  } catch (err) {
    yield put(fetchWorkingHoursFailure(err));
  }
}

export function* doUpdateWorkingHours(action) {
  try {
    const { id, unlock = false, body } = action.payload;
    const results = yield call(callApi, {
      endpoint: `planning/workingHours/${id}?unlock=${unlock}`,
      options: {
        method: 'POST',
        body: JSON.stringify(body),
        errorMessage: `Could not update working hours for ${id}`,
        retryAction: action,
      },
    });
    yield put(updateWorkingHoursSuccess(results));
  } catch (err) {
    yield put(updateWorkingHoursFailure(err));
  }
}

export function* doRestoreWorkingHours(action) {
  try {
    const { id, unlock = false } = action.payload;
    const results = yield call(callApi, {
      endpoint: `planning/workingHours/${id}?unlock=${unlock}`,
      options: {
        method: 'DELETE',
        errorMessage: `Could not restore working hours for ${id}`,
        retryAction: action,
      },
    });
    yield put(restoreWorkingHoursSuccess(results));
  } catch (err) {
    yield put(restoreWorkingHoursFailure(err));
  }
}

function* watchFetchPlants() {
  yield takeLatest(actionTypes.FETCH_WORKING_PLANTS_REQUEST, doFetchPlants);
}

function* watchFetchWorkingHours() {
  yield takeLatest(actionTypes.FETCH_WORKING_HOURS_REQUEST, doFetchWorkingHours);
}

function* watchUpdateWorkingHours() {
  yield takeLatest(actionTypes.UPDATE_WORKING_HOURS_REQUEST, doUpdateWorkingHours);
}

function* watchRestoreWorkingHours() {
  yield takeLatest(actionTypes.RESTORE_WORKING_HOURS_REQUEST, doRestoreWorkingHours);
}

export default [
  fork(watchFetchPlants),
  fork(watchFetchWorkingHours),
  fork(watchUpdateWorkingHours),
  fork(watchRestoreWorkingHours),
];
